export default __webpack_public_path__ + "static/media/CreditCard.dc7bc382.svg";